import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gsury7wafe: FaireBrandEntity = {
  token: "b_gsury7wafe",
  type: "brand",
  name: "JB Wholesale",
  avatarUrl:
    "https://cdn.faire.com/fastly/5b60f73210a1b4186bea070699cb044fa223ffcab1099b763f520b013bfc58c5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6d107d220068aec4d90cdf2eb4d9cf7f242c9f8baa4e10f78a5865206c6406fe.png",
  logoUrl:
    "https://cdn.faire.com/fastly/5b60f73210a1b4186bea070699cb044fa223ffcab1099b763f520b013bfc58c5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6d107d220068aec4d90cdf2eb4d9cf7f242c9f8baa4e10f78a5865206c6406fe.png",
  location: "RUSSSELLVILLE, AR, USA",
  minimumOrderDollars: 0,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "In a small town where everybody knows your name and community means everything, our brand was born at the kitchen table — between nap times, school drop-offs, and late-night embroidery runs.\n\nI’m a mama first and a maker always.\n\nWhat started as a creative outlet quickly became a dream: designing graphic tees and embroidery pieces that feel personal, meaningful, and made to last. Every design is inspired by real life — motherhood, small-town pride, faith, grit, humor, and the beautiful chaos in between.\n\nWe believe in:\n\nComfortable, quality tees that become everyday favorites\n\nThoughtful embroidery that adds timeless detail\n\nDesigns that tell a story, spark conversation, or make someone feel seen\n\nSupporting other small businesses and boutiques who value heart behind the product\n\nFrom digitizing embroidery files after bedtime to hand-pressing tees in our home studio, every piece is created with intention. We aren’t a mass-production company — we’re a small-town, mama-owned business that cares deeply about craftsmanship and connection.\n\nWhen you stock our pieces in your shop, you’re not just carrying apparel.\nYou’re carrying a story of family, faith, hard work, and chasing a dream in between snack breaks.\n\nThank you for supporting small.\nThank you for supporting handmade.\nAnd thank you for supporting a mama with a big vision.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:59.585Z",
    importedBy: "entity-db-cli",
  },
};
